// extracted by mini-css-extract-plugin
module.exports = {"table":"Rechtstatsachen_table__ZyrF5"};